module.exports = __webpack_public_path__ + "img/404.5a2c196b.svg";